import { Button, Row, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.85);
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Warn = styled.div`
  width: min(90vw, 360px);
  padding: 28px 32px;
  border-radius: 20px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Alert = ({ text, accept = () => null, refuse = () => null, acceptText, refuseText }) => {
  const { t } = useTranslation();

  text = text ? text : t('common.areYouSure');

  return (
    <Wrapper>
      <Warn>
        <Text center>{text}</Text>

        <Row marg="16px 0 0" between wid="100%" gap="10px">
          <Button
            onClick={accept}
            app
            bg={theme.GREY_60}
            pad="9px 24px"
            text={acceptText || t('common.accept')}
          />

          <Button
            onClick={refuse}
            app
            bg={theme.SECONDARY}
            pad="9px 24px"
            text={refuseText || t('common.refuse')}
          />
        </Row>
      </Warn>
    </Wrapper>
  );
};

export default Alert;
